

module.exports = __webpack_require__.stylable.create(
    "Widget3478578363",
    {"classes":{"root":"Widget3478578363__root","wrapper":"Widget3478578363__wrapper","title":"Widget3478578363__title","description":"Widget3478578363__description","contentBox":"Widget3478578363__contentBox","contentTitle":"Widget3478578363__contentTitle","text":"Widget3478578363__text","link":"Widget3478578363__link","ctaButton":"Widget3478578363__ctaButton"},"vars":{},"stVars":{"baseMargin":"32px"},"keyframes":{}},
    "",
    8,
    "Widget3478578363",
    null
);
